import { render, staticRenderFns } from "./CenterManagement.vue?vue&type=template&id=71ce9d2e&scoped=true"
import script from "./CenterManagement.vue?vue&type=script&lang=js"
export * from "./CenterManagement.vue?vue&type=script&lang=js"
import style0 from "./CenterManagement.vue?vue&type=style&index=0&id=71ce9d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce9d2e",
  null
  
)

export default component.exports